import { render } from "./SidebarGroup.vue?vue&type=template&id=ced47b28&ts=true"
import script from "./SidebarGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarGroup.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ced47b28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ced47b28', __exports__)) {
    api.reload('ced47b28', __exports__)
  }
  
  module.hot.accept("./SidebarGroup.vue?vue&type=template&id=ced47b28&ts=true", () => {
    api.rerender('ced47b28', render)
  })

}


export default __exports__